import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import { getUserFriendlyMessagesForErrorResponse } from '../../../errors/user-friendly-error-message-service';
import { useShipFromContext } from '../../contexts/ship-from-context';

export const Errors = () => {
  const { errors } = useShipFromContext();

  const userFriendlyErrors = getUserFriendlyMessagesForErrorResponse({ Errors: errors });

  if (!userFriendlyErrors.errors.length) {
    return null;
  }

  return (
    <BannerMessageV2
      content={
        <ul>
          {userFriendlyErrors.errors.map((error, index) => {
            return (
              <li key={`ship-from-modal-error-${index}`}>
                <FormattedMessage {...error.messageDescriptor} values={error.values} />
              </li>
            );
          })}
        </ul>
      }
      status={BannerStatus.Error}
    />
  );
};
